import { Box, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";

interface IdentificationStepProps {
  urbanPartner: any;
  slug?: string;
  navigate: (to: string) => void;
}

const IdentificationStep: React.FC<IdentificationStepProps> = ({
  urbanPartner,
  slug,
}) => {
  return (
    <Box>
      <Typography variant="h4" component="h2" gutterBottom>
        Identificação
      </Typography>
      {urbanPartner ? (
        <Typography variant="body1">
          Que bom te ver por aqui, {urbanPartner.name}! Vamos continuar com seu
          pedido?
        </Typography>
      ) : (
        <Box sx={{ textAlign: "center", mt: 4 }}>
          <Typography variant="body1" gutterBottom>
            Para garantir que sua feira chegue direitinho, precisamos saber quem
            você é
          </Typography>
          <Link to={`/login?slug=${slug}&page=checkout`}>
            <Button variant="contained" size="large" sx={{ mt: 2 }}>
              Me identificar
            </Button>
          </Link>
        </Box>
      )}
    </Box>
  );
};

export default IdentificationStep;
